import { combineReducers } from 'redux';
import AuthReducer from './services/Auth/AuthReducer';
import signUp from './modules/SignUp/SignUP/signUp.reducer';
import appsignUp from './modules/AppSignUp/appSignUp.reducer';
import loader from './shared/_reducers/loader.reducer';
import LoginReducer from './modules/Login/Login/Reducers/LoginReducer';
import { notification } from './shared/_reducers/notification.reducer';
import { homePageReducer } from './modules/Home/HomePageReducer';
import { applicationsPageReducer } from './modules/Applications/ApplicationsPageReducer';
import { termsConditionsReducer } from './components/TermsConditions/TermsConditionsReducer';
import { privacyPolicyReducer } from './components/PrivacyPolicy/PrivacyPolicyReducer';
import { cookiesPolicyReducer } from './components/CookiesPolicy/CookiesPolicyReducer';
import { footerLinksReducer } from './components/Footer/FooterReducer';

const rootReducer = combineReducers({
  AuthReducer,
  signUp,
  loader,
  LoginReducer,
  appsignUp,
  notification,
  homePageReducer,
  applicationsPageReducer,
  termsConditionsReducer,
  privacyPolicyReducer,
  cookiesPolicyReducer,
  footerLinksReducer,
});

export default rootReducer;
